import { IAccountDetailsResponse } from "app/bus/type";
import { IBanner } from "components/imageGrid";

export type ModalState = {
  modalName: string;
  isShowing: boolean;
  actionType: any;
};

export interface CarouselData {
  inCarousel: boolean;
  banner: IBanner[];
}
export type BottomBanners = IBanner[];
export type BannerData = {
  time: { to: Date; from: Date };
  mobileBannerList: [[CarouselData], [BottomBanners]];
};

export type BannerList = {
  0: CarouselData[];
  1: BottomBanners[];
};
export type xGlobalModal = {
  isSignedIn: boolean | undefined;
  abData: ABResponse;
  userDetails: IAccountDetailsResponse | undefined;
  bannerData:
    | {
        0: CarouselData[];
        1: BottomBanners[];
      }
    | Record<string, unknown>;
};

export type ModalAction =
  | { type: "OPEN_LOGIN_MODAL" }
  | { type: "CLOSE_LOGIN_MODAL" }
  | { type: "" };

export type ModalDispatch = (action: ModalAction) => void;

export enum Types {
  LOGIN_MODAL = "LOGIN_MODAL",
}

export interface ABResponse {
  [key: string]: string;
}
